'use strict';
rcElementRange.$inject = ['$http', '$compile', '$templateCache', '$q', 'accountStructureService', 'ACCOUNT_TYPES'];
angular.module('schoolLinqApp').directive('rcElementRange', rcElementRange);
require('@ajs/templates/reports/rcElementRange.html');
require('@ajs/templates/reports/rcElementRangeSlimDisplay.html');

function rcElementRange($http, $compile, $templateCache, $q, accountStructureService, ACCOUNT_TYPES) {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			ngModel: '=',
			isDisabled: '=',
			fundOnly: '=',
			budgetSetup: '=',
			isSlimDisplay: '=',
		},
		replace: true,
		restrict: 'E',
		link: function (scope, iElement, iAttrs) {
			var tempUrl = '/templates/reports/rcElementRange.html';
			if (scope.isSlimDisplay === true) {
				tempUrl = '/templates/reports/rcElementRangeSlimDisplay.html';
			}
			$http.get(tempUrl, { cache: $templateCache }).then(function (tplContent) {
				iElement.replaceWith($compile(tplContent.data)(scope));
			});
		},
		controller: [
			'$scope',
			function ($scope) {
				$scope.viewModel = {
					assetFundElementIndex: 0,
					liabilityFundElementIndex: 0,
					reserveFundElementIndex: 0,
					expenseFundElementIndex: 0,
					revenueFundElementIndex: 0,
					accountTypes: [{ Id: 0, Description: 'All' }],
				};
				if (!$scope.ngModel) {
					$scope.ngModel = [
						{
							type: null,
						},
					];
				}
				$scope.loadingElementRange = $q.all([loadAccountStructures()]).then(function () {
					loadAccountTypes();
				});

				function loadAccountStructures() {
					return accountStructureService.getStructure().then(finishLoadingAccountStructures);

					function finishLoadingAccountStructures(response) {
						$scope.viewModel.assetFundElementIndex = response.data.accountStructure.AssetElementFundIndex;
						$scope.viewModel.expenseFundElementIndex = response.data.accountStructure.ExpenseElementFundIndex;
						$scope.viewModel.liabilityFundElementIndex = response.data.accountStructure.LiabilityElementFundIndex;
						$scope.viewModel.reserveFundElementIndex = response.data.accountStructure.ReserveElementFundIndex;
						$scope.viewModel.revenueFundElementIndex = response.data.accountStructure.RevenueElementFundIndex;
						return angular.noop;
					}
				}

				function loadAccountTypes() {
					return accountStructureService.getAccountTypes().then(finishLoadingAccountTypes);

					function finishLoadingAccountTypes(response) {
						$scope.viewModel.accountTypes = response.data.accountTypes;

						if ($scope.budgetSetup) {
							$scope.viewModel.accountTypes = _.filter(response.data.accountTypes, function (accntType) {
								return accntType.Id === ACCOUNT_TYPES.Expense || accntType.Id === ACCOUNT_TYPES.Revenue;
							});
						}
						$scope.viewModel.accountTypes.unshift({
							Id: 0,
							Description: 'All',
						});

						if ($scope.fundOnly) {
							for (let i = 0; i < $scope.viewModel.accountTypes.length; i++) {
								if ($scope.viewModel.accountTypes[i].Id === ACCOUNT_TYPES.Asset) {
									$scope.viewModel.accountTypes[i].FundElementIndex = $scope.viewModel.assetFundElementIndex;
									$scope.viewModel.accountTypes[i].ElementMap = $scope.viewModel.accountTypes[i].ElementMap.split('.')[
										$scope.viewModel.assetFundElementIndex
									];
									$scope.viewModel.accountTypes[i].Mask = $scope.viewModel.accountTypes[i].Mask.split('.')[
										$scope.viewModel.assetFundElementIndex
									];
								} else if ($scope.viewModel.accountTypes[i].Id === ACCOUNT_TYPES.Liability) {
									$scope.viewModel.accountTypes[i].FundElementIndex = $scope.viewModel.liabilityFundElementIndex;
									$scope.viewModel.accountTypes[i].ElementMap = $scope.viewModel.accountTypes[i].ElementMap.split('.')[
										$scope.viewModel.liabilityFundElementIndex
									];
									$scope.viewModel.accountTypes[i].Mask = $scope.viewModel.accountTypes[i].Mask.split('.')[
										$scope.viewModel.liabilityFundElementIndex
									];
								} else if ($scope.viewModel.accountTypes[i].Id === ACCOUNT_TYPES.Reserve) {
									$scope.viewModel.accountTypes[i].FundElementIndex = $scope.viewModel.reserveFundElementIndex;
									$scope.viewModel.accountTypes[i].ElementMap = $scope.viewModel.accountTypes[i].ElementMap.split('.')[
										$scope.viewModel.reserveFundElementIndex
									];
									$scope.viewModel.accountTypes[i].Mask = $scope.viewModel.accountTypes[i].Mask.split('.')[
										$scope.viewModel.reserveFundElementIndex
									];
								} else if ($scope.viewModel.accountTypes[i].Id === ACCOUNT_TYPES.Revenue) {
									$scope.viewModel.accountTypes[i].FundElementIndex = $scope.viewModel.revenueFundElementIndex;
									$scope.viewModel.accountTypes[i].ElementMap = $scope.viewModel.accountTypes[i].ElementMap.split('.')[
										$scope.viewModel.revenueFundElementIndex
									];
									$scope.viewModel.accountTypes[i].Mask = $scope.viewModel.accountTypes[i].Mask.split('.')[
										$scope.viewModel.revenueFundElementIndex
									];
								} else if ($scope.viewModel.accountTypes[i].Id === ACCOUNT_TYPES.Expense) {
									$scope.viewModel.accountTypes[i].FundElementIndex = $scope.viewModel.expenseFundElementIndex;
									$scope.viewModel.accountTypes[i].ElementMap = $scope.viewModel.accountTypes[i].ElementMap.split('.')[
										$scope.viewModel.expenseFundElementIndex
									];
									$scope.viewModel.accountTypes[i].Mask = $scope.viewModel.accountTypes[i].Mask.split('.')[
										$scope.viewModel.expenseFundElementIndex
									];
								}
							}
						}

						return angular.noop;
					}
				}

				$scope.$watch(
					'element',
					function (toNew, toOld) {
						if (toNew && toNew !== toOld) {
							$scope.elements = $scope.element.split('.');
						}
					},
					true
				);

				$scope.$watch(
					'mask',
					function (toNew, toOld) {
						if (toNew && toNew !== toOld) {
							$scope.masks = $scope.mask.split('.');
						}
					},
					true
				);

				$scope.queryOptions = [
					{
						displayName: 'is > or =',
						query: 'greaterthanorequal',
					},
					{
						displayName: 'is < or =',
						query: 'lessthanorequal',
					},
					{
						displayName: 'is >',
						query: 'greaterthan',
					},
					{
						displayName: 'is <',
						query: 'lessthan',
					},
					{
						displayName: '=',
						query: 'equal',
					},
				];

				$scope.addFilter = function () {
					// Only include 'All' in the list of Account Types when there is only one filter.
					let allIdx = _.findIndex($scope.viewModel.accountTypes, function (item) {
						return item.Id === 0;
					});
					if (allIdx !== -1) $scope.viewModel.accountTypes.splice(allIdx, 1);
					$scope.ngModel.push({
						type: null,
						queries: [{}],
					});
				};

				$scope.removeFilter = function (index) {
					$scope.ngModel.splice(index, 1);
					// Only include 'All' in the list of Account Types when there is only one filter.
					if ($scope.ngModel.length === 1)
						$scope.viewModel.accountTypes.unshift({
							Id: 0,
							Description: 'All',
						});
				};

				$scope.addQuery = function (filter) {
					filter.queries.push({ AccountTypeId: filter.type.Id });
				};

				$scope.removeQuery = function (filter, query) {
					let index = _.findIndex(filter.queries, {
						$$hashKey: query.$$hashKey,
					});
					filter.queries.splice(index, 1);
				};
			},
		],
	};
}
